// Which XSTUDI tenant a page URL belongs to. This is the rule Login.vue's
// initData has always used: "western" anywhere in the URL wins, then
// "nation", and anything else (localhost, IP, demo host) falls back to
// Western.
export const TENANT_WESTERN = 'western';
export const TENANT_NATION = 'nation';

export function resolveTenantFromUrl(url) {
  const value = typeof url === 'string' ? url : '';
  if (value.includes(TENANT_WESTERN)) return TENANT_WESTERN;
  if (value.includes(TENANT_NATION)) return TENANT_NATION;
  return TENANT_WESTERN;
}
